import PropTypes from 'prop-types';
import Button from '@decisiv/ui-components/lib/components/Button';
import ChevronDown from '@decisiv/iconix/lib/components/ChevronDown';
import ChevronUp from '@decisiv/iconix/lib/components/ChevronUp';
import HelpMessage from '@decisiv/ui-components/lib/atoms/InputField/HelpMessage';

// Runtime fixes for KDS prop-type declarations that fire for every consumer
// regardless of usage. The lib is CommonJS, so editing the shared module
// objects before the first render covers the whole app. Remove each block once
// KDS ships the corresponding fix.
/* eslint-disable react/forbid-foreign-prop-types -- editing KDS's declarations is the point */

// HelpMessage declares contentLength as required but defaults it to 0
// internally, and KDS's own SearchInput never passes it.
if (HelpMessage.propTypes) {
  HelpMessage.propTypes.contentLength = PropTypes.number;
}

// Button requires aria-label when text is empty. Two KDS-internal buttons never
// pass one: the Combobox expand chevron (Combobox/Target.js: ChevronDown/Up
// icon, tabIndex -1, mirrors the input) and the SelectMenu toggle, which is
// labelled via aria-labelledby instead. Accept exactly those; everything else,
// including our own icon buttons, still goes through the original check.
const isKdsComboboxChevron = ({ icon, tabIndex }) =>
  tabIndex === -1 && (icon === ChevronDown || icon === ChevronUp);

if (Button.propTypes) {
  const original = Button.propTypes['aria-label'];
  Button.propTypes['aria-label'] = (props, ...rest) =>
    props['aria-labelledby'] || isKdsComboboxChevron(props)
      ? null
      : original(props, ...rest);
}
/* eslint-enable react/forbid-foreign-prop-types */
